module.exports = __webpack_public_path__ + "static/media/car-avatar.90a0e035.png";